export const GOOGLE_KEY = "AIzaSyAFlCwYSwpkCzVTh6t34ldOkyazyZPkzCI";
const ShortmonthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export function formatDate(inputDate) {
  const dateObj = new Date(inputDate + 'T00:00:00');
  let month = ShortmonthNames[dateObj.getMonth()];
  let day = dateObj.getDate();
  let year = dateObj.getFullYear();
  return `${day} ${month}, ${year}`;
}
export const formatAMPM = (date) => {
  if (date) {

    // Agar already AM/PM format me hai
    if (
      date.toUpperCase().includes("AM") ||
      date.toUpperCase().includes("PM")
    ) {
      return date;
    }

    const myArray = date.split(":");
    let hours = parseInt(myArray[0]);
    const minutes = myArray[1];
    const ampm = hours >= 12 ? " PM" : " AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    return `${hours}:${minutes}${ampm}`;
  }
};

export const currentDate = () => {
  return new Date().toISOString().split("T")[0];
};

export const useDragDrop = (onFileSelect, onDragOver, onDragLeave, onDrop) => {
  return {
    handleDragOver: (e) => {
      e.preventDefault();
      e.stopPropagation();
      onDragOver(true);
    },
    handleDragLeave: (e) => {
      e.preventDefault();
      e.stopPropagation();
      onDragLeave(false);
    },
    handleDrop: (e) => {
      e.preventDefault();
      e.stopPropagation();
      onDragLeave(false);
      const file = e.dataTransfer.files[0];
      onFileSelect(file);
    },
  };
};

export const CustomToolTip = ({ type, title }) => {
  if (!type || !title) return null;

  let tooltipText = "";
  if (type === "view") {
    tooltipText = `View ${title} Detail`;
  } else if (type === "edit") {
    tooltipText = `Edit ${title} Detail`;
  } else if (type === "delete") {
    tooltipText = `Delete ${title} Detail`;
  }

  return <span className="custom-tooltip">{tooltipText}</span>;
};

